import React, { memo } from "react";
import { Grid, Select, Input, MenuItem, Checkbox, IconButton } from "@mui/material";
import { areEqual } from "react-window";
import AdjustIcon from "@mui/icons-material/Adjust";
import { MenuProps } from "../scripts/constants";

const AllRows = memo(({ data, index, style }) => {
  const {
    products,
    columns,
    displayProductInfo,
    handleChange,
    handleClickDefaultUPC,
  } = data;

  const itemData = products[index];

  const last = !products[index + 1]
    ? true
    : index < products.length
      ? products[index].item_code.item_code !==
        products[index + 1].item_code.item_code
      : false;

  const iActive = products[index].active;

  return (
    <div
      key={`row-${index}`}
      style={style}
      className={`row row-${index} ${(index + 1) % 2 ? "odd" : "even"} ${
        last ? "last" : ""
      } ${iActive === false ? "iInactive" : ""}`}
    >
      <div className={`row-info row-${index}-info `}>
        {columns.map((column) => {
          const value = itemData[column.id];

          return (
            <div
              key={`row-${index}-column-${column.id}`}
              className={`column column-${column.id} ${
                ["item_code", "upc", "name", "stock_level"].includes(column.id)
                  ? (index + 1) % 2
                    ? "odd"
                    : "even"
                  : ""
              }`}
              title={["name", "upc"].includes(column.id) ? value : ""}
              {...(["upc"].includes(column.id)
                ? { onClick: () => displayProductInfo(`row-${index}`) }
                : undefined)}
            >
              {column.exposed ? (
                {
                  input: (
                    <input
                      className="inputPickList inputPickListText"
                      name={`${index}-${column.id}`}
                      value={value}
                      onChange={handleChange}
                    />
                  ),
                  checkbox: (
                    <Checkbox
                      name={`${index}-${column.id}`}
                      value={
                        !["name", "upc", "item_code"].includes(column.id)
                          ? itemData.order_lists.includes(column.id)
                          : value
                      }
                      checked={
                        !["name", "upc", "item_code"].includes(column.id)
                          ? itemData.order_lists.includes(column.id)
                          : !!value
                      }
                      onChange={handleChange}
                      size="small"
                    />
                  ),
                  select:
                    value === false ? (
                      <></>
                    ) : column.id === "name" ? (
                      <Grid container>
                        <Grid item xs={true}>
                          <select
                            className={`inputPickList inputPickListSelect${
                              itemData.acceptable_substitutions.length
                                ? ""
                                : " inputPickListSelectNoArrow"
                            }`}
                            name={`${index}-${column.id}`}
                            value={itemData}
                            onChange={handleChange}
                            disabled={itemData.out_of_stock}
                          >
                            <option value={itemData}>{itemData.name}</option>
                            {itemData.hasOwnProperty("acceptable_substitutions") &&
                              itemData.acceptable_substitutions.map((item) => (
                                <option
                                  key={`_acceptable_substitution_${item.upc}`}
                                  value={`_acceptable_substitution_${item.upc}`}
                                >
                                  {item.name}
                                </option>
                              ))}
                          </select>
                        </Grid>
                      </Grid>
                    ) : (
                      <Select
                        fullWidth
                        input={<Input />}
                        name={`${index}-${column.id}`}
                        value={value}
                        onChange={handleChange}
                        MenuProps={MenuProps}
                        disabled={itemData.out_of_stock}
                      >
                        <MenuItem value={value}>{"" + value}</MenuItem>
                      </Select>
                    ),
                  button: "",
                }[column.exposedAs || "input"]
              ) : column.id === "item_code" ? (
                products[index].item_code.item_code
              ) : column.id === "stock_level" ? (
                <>
                  <span className="stock-level-value">{value}</span>
                  <IconButton
                    title={`[${itemData.order_lists.length}/${columns.length - 3}]`}
                    onClick={() => handleClickDefaultUPC(`row-${index}`)}
                  >
                    <AdjustIcon />
                  </IconButton>
                </>
              ) : column.id.includes("price") || column.id.includes("total") ? (
                value === null ? "N/A" : "$" + (+value).toFixed(2)
              ) : typeof value === "boolean" ? (
                "" + value
              ) : typeof value === "object" && value === null ? (
                "N/A"
              ) : (
                value || 0
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}, areEqual);

export default AllRows;